module.exports = __webpack_public_path__ + "img/eprf-download-grey.8596c855.png";